import { Component, Input, OnInit } from '@angular/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { MapsService } from 'app/modules/maps/maps.service';

@Component({
  selector: 'app-organization-popup',
  templateUrl: './organization-popup.component.html',
  styleUrls: ['./organization-popup.component.scss']
})
export class OrganizationPopupComponent implements OnInit {

  @Input() data: any;
  constructor(
    private _localisationService: LocalisationService,
    private _mapService: MapsService
  ) { }

  createNewJob(data: any): void {
    const propertyData = {
      module: 'ORGANIZATION',
      data: data
    };
    this._mapService.newJobDrawerToggler.next(propertyData);
  }

  openPreview(data?: any): void {
    const previewData = {
      'uid' : data.organization_uid,
      'module' : 'ORGANIZATION'
    };
    this._mapService.previewUid.next(previewData);
  }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
  }

}
